import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  assertViewerLens2aypbnpatof3k as assertViewerLens,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  PayAppStatus_Pending_getInstance2ma8qo3my1dmm as PayAppStatus_Pending_getInstance,
  get_individualStatus1waisigfu538t as get_individualStatus,
  getPaymentData33dmvsrmw11t5 as getPaymentData,
  overallStatus206eg9g5yqouc as overallStatus,
} from './data.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { WaitDrawsDialog11kr3h4lqhbji as WaitDrawsDialog } from '../../../../dialogs/PagedUserTextInputDialog.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { DrawWaitedDetails301fxrq4n3zo5 as DrawWaitedDetails } from '../../../../dialogs/BasicFlowForms.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  title1ahgushtajx2d as title,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  timesx4ey3un7ihw1 as times,
  divkhq3vjih9fcw as div,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../theming/states.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
  get_dangerButtonciwpmvl7jmt2 as get_dangerButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { PayApplicationmbkdcq3ut87x as PayApplication } from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Data3qblafqxenieu as Data } from '../../../../screens/common/AuthorizedProjectView.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ReactiveMutableSet2bktc9g3zyrtk as ReactiveMutableSet } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableSet.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  DarkSection_getInstance2gsqmxxo07g1v as DarkSection_getInstance,
  get_darkSection25mxxvxk8ts3b as get_darkSection,
} from '../../../../theming/sections.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { PayAppSummary1iyji3gt9nfm0 as PayAppSummary } from './PayAppSummary.mjs';
import {
  label287uhiq3m9m4z as label2,
  labeledSection16775qn7m7foh as labeledSection,
} from '../../../label2.mjs';
import { TabSemantics3r0nvsoryso8y as TabSemantics } from '../../../../theming/tabs.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { Companion_getInstance33aui7uk8ap15 as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../files/renderFiles.mjs';
import {
  ReviewSelectionSemantic_getInstance79bht8dtdj2a as ReviewSelectionSemantic_getInstance,
  DeniedSemantic_getInstanceb7su0ait1it4 as DeniedSemantic_getInstance,
  ApprovedSemantic_getInstance10vizqzbc90jx as ApprovedSemantic_getInstance,
} from '../../../../theming/approval.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { containsDynamic2tw0myh68yr3u as containsDynamic } from '../../../../../utils/utils.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_requiredMembershipRole1cjo4vwylx1kv as get_requiredMembershipRole,
  get_finishRegistrationMessage1yrf9ce4f09f0 as get_finishRegistrationMessage,
  get_awaitingApprovalMessage2f85iqlczrbum as get_awaitingApprovalMessage,
  renderFinishRegistrationc1cqjl7so0e8 as renderFinishRegistration,
  renderAwaitingApproval2nft16oqsuwts as renderAwaitingApproval,
  render2ibcvtmr1nr93 as render,
  MightBeContractorPage1c5hm6d3mwsqz as MightBeContractorPage,
} from '../../../../screens/contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SummarySection_Requested_instance;
var SummarySection_Actual_instance;
function values() {
  return [SummarySection_Requested_getInstance(), SummarySection_Actual_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var SummarySection_entriesInitialized;
function SummarySection_initEntries() {
  if (SummarySection_entriesInitialized)
    return Unit_instance;
  SummarySection_entriesInitialized = true;
  SummarySection_Requested_instance = SummarySection().mhc('Requested', 0, 'Requested');
  SummarySection_Actual_instance = SummarySection().mhc('Actual', 1, 'Actual');
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = assertViewerLens($this.nhc_1.gf5_1, $this.nhc_1.df5_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = $this.ohc_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = element.shc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (get_status(element_0).equals(PayAppStatus_Pending_getInstance())) {
      destination_0.v(element_0);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    var tmp = $this.phc_1.ofn(element_1.q6v_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var result = tmp;
    $this.qhc_1.bfw_1.bft(result);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.bhd_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var payItems = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var session = tmp_0;
    var endpoints = session.tfw().kfg_1;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, PayAppDetails$actionBar$slambda$slambda$slambda_0(payItems, endpoints, session));
  }
  return Unit_instance;
}
var PayAppDetails$actionBar$slambda$slambda$slambdaClass;
function PayAppDetails$actionBar$slambda$slambda$slambda() {
  if (PayAppDetails$actionBar$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($payItems, $endpoints, $session) {
        this.ohc_1 = $payItems;
        this.phc_1 = $endpoints;
        this.qhc_1 = $session;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppDetails$actionBar$slambda$slambda$slambdaClass = $;
  }
  return PayAppDetails$actionBar$slambda$slambda$slambdaClass;
}
function PayAppDetails$actionBar$slambda$slambda$slambda_0($payItems, $endpoints, $session) {
  var i = new (PayAppDetails$actionBar$slambda$slambda$slambda())($payItems, $endpoints, $session);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var PayAppDetails$actionBar$slambda$slambdaClass;
function PayAppDetails$actionBar$slambda$slambda() {
  if (PayAppDetails$actionBar$slambda$slambdaClass === VOID) {
    class $ {
      constructor($pending) {
        this.bhd_1 = $pending;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppDetails$actionBar$slambda$slambdaClass = $;
  }
  return PayAppDetails$actionBar$slambda$slambdaClass;
}
function PayAppDetails$actionBar$slambda$slambda_0($pending) {
  var i = new (PayAppDetails$actionBar$slambda$slambda())($pending);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this.chd_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6v_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_0);
      }
    }
    var payItems = destination;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.tfw().kfg_1.mfn(payItems, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.dhd_1.kf5_1.v3();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ehd_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.fhd_1.kf5_1.kl(element.rhc_1.kf9_1)) {
      destination.v(element);
    }
  }
  var selectedPending = destination;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s_0 = selectedPending.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_0 = sum;
    var tmp0_elvis_lhs = element_0.yhc_1;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = Companion_instance.p91(0n);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var tmp$ret$4 = tmp_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$4);
  }
  var total = sum;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fhd_1.gf5_1.khd_1;
  var tmp_3 = await_0(this_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp$ret$6 = tmp_3;
  var retention = MonetaryValue__times_impl_hlr6p7(total, tmp$ret$6.u97());
  var totalMinusRetention = MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(total, retention));
  var tmp_4 = get_dialogStack();
  var tmp_5;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.ghd_1;
  var tmp_6 = await_0(this_2, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  if (tmp_6) {
    tmp_5 = 'Pay Draw';
  } else {
    tmp_5 = 'Pay ' + selectedPending.p1() + ' Draw Items';
  }
  var tmp_7 = tmp_5;
  var tmp_8 = 'Pay ' + totalMinusRetention + ' out of escrow to contractor?';
  var tmp_9 = 'Pay ' + totalMinusRetention;
  tmp_4.xgd(new (GenericConfirmationDialog())(tmp_7, tmp_8, VOID, tmp_9, VOID, VOID, VOID, VOID, VOID, VOID, PayAppDetails$actionBar$slambda$slambda_2(selectedPending, $this.fhd_1)));
  return Unit_instance;
}
var PayAppDetails$actionBar$slambda$slambdaClass_0;
function PayAppDetails$actionBar$slambda$slambda_1() {
  if (PayAppDetails$actionBar$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($selectedPending, this$0) {
        this.chd_1 = $selectedPending;
        this.dhd_1 = this$0;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppDetails$actionBar$slambda$slambdaClass_0 = $;
  }
  return PayAppDetails$actionBar$slambda$slambdaClass_0;
}
function PayAppDetails$actionBar$slambda$slambda_2($selectedPending, this$0) {
  var i = new (PayAppDetails$actionBar$slambda$slambda_1())($selectedPending, this$0);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ihf_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.jhf_1.kf5_1.kl(element.rhc_1.kf9_1)) {
      destination.v(element);
    }
  }
  var selectedPending = destination;
  var tmp_0 = get_dialogStack();
  var tmp_1 = toList(selectedPending);
  tmp_0.xgd(WaitDrawsDialog(tmp_1, PayAppDetails$actionBar$slambda$slambda_4($this.jhf_1)));
  return Unit_instance;
}
var PayAppDetails$actionBar$slambda$slambdaClass_1;
function PayAppDetails$actionBar$slambda$slambda_3() {
  if (PayAppDetails$actionBar$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.khf_1 = this$0;
      }
      lhf(value, $completion) {
        this.khf_1.kf5_1.kam(value);
      }
      s2(p1, $completion) {
        return this.lhf(p1 instanceof UUID() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppDetails$actionBar$slambda$slambdaClass_1 = $;
  }
  return PayAppDetails$actionBar$slambda$slambdaClass_1;
}
function PayAppDetails$actionBar$slambda$slambda_4(this$0) {
  var i = new (PayAppDetails$actionBar$slambda$slambda_3())(this$0);
  var l = (value, $completion) => i.lhf(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mhf_1.hf5_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var items = tmp;
  var tmp_0 = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.mhf_1.ef5_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = element.shc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var tmp_3 = destination;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(items, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element_0.rhc_1.kf9_1, element_0.rhc_1);
    destination_0.s3(pair.af_1, pair.bf_1);
  }
  var tmp_4 = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.mhf_1.gf5_1.rhd_1;
  var tmp_5 = await_0(this_2, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5.f5c_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.mhf_1.gf5_1.thd_1;
  var tmp_7 = await_0(this_3, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp$ret$14 = tmp_7;
  tmp_0.xgd(new (DrawWaitedDetails())(tmp_2, tmp_3, tmp_4, tmp_6, tmp$ret$14.x5i_1));
  return Unit_instance;
}
var SummarySectionClass;
function SummarySection() {
  if (SummarySectionClass === VOID) {
    class $ extends Enum() {
      static mhc(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.lhc_1 = displayName;
        return $this;
      }
      g90() {
        return this.lhc_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'SummarySection', VOID, VOID, [HasDisplayName(), Enum()]);
    SummarySectionClass = $;
  }
  return SummarySectionClass;
}
function entry($this, _this__u8e3s4, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.jbb(get_centered(view), bodyBold(view, key));
  var tmp = view.ibb(get_expanding(view), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.bbs(Align_End_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_3(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_3(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = value($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function requestedSummary($this, _this__u8e3s4) {
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var workValue = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$remember.baj($this.hf5_1);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp0_safe_receiver = element.shc_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6v_1;
      var tmp_0;
      var tmp_1 = tmp1_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.p91(0n);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var tmp$ret$0 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
    }
    var tmp$ret$1 = sum;
    return new (MonetaryValue())(tmp$ret$1);
  });
  entry($this, view, 'Work Value', ($this$entry) => $this$entry.baj(workValue));
  entry($this, view, 'Less Retention', ($this$entry) => new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7($this$entry.baj(workValue).a5s_1, $this$entry.baj($this.gf5_1.khd_1).u97())));
  greySeparator(view);
  entry($this, view, 'Requested', ($this$entry) => {
    // Inline function 'kotlin.let' call
    var it = $this$entry.baj(workValue).a5s_1;
    var tmp$ret$3 = MonetaryValue__minus_impl_jw9qyp(it, MonetaryValue__times_impl_hlr6p7(it, $this$entry.baj($this.gf5_1.khd_1).u97()));
    return new (MonetaryValue())(tmp$ret$3);
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actualsSummary($this, _this__u8e3s4) {
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var approved = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$remember.baj($this.hf5_1);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_0;
        if (!(tmp0_safe_receiver.u6v_1 == null)) {
          tmp_0 = tmp0_safe_receiver;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_0);
      }
    }
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var tmp_1 = sum;
      var tmp$ret$9 = element_0.t6v_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$9);
    }
    var tmp$ret$10 = sum;
    return new (MonetaryValue())(tmp$ret$10);
  });
  entry($this, view, 'Approved', ($this$entry) => $this$entry.baj(approved));
  entry($this, view, 'Less Retention', ($this$entry) => new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7($this$entry.baj(approved).a5s_1, $this$entry.baj($this.gf5_1.khd_1).u97())));
  greySeparator(view);
  entry($this, view, 'Paid', ($this$entry) => {
    // Inline function 'kotlin.let' call
    var it = $this$entry.baj(approved).a5s_1;
    var tmp$ret$12 = MonetaryValue__minus_impl_jw9qyp(it, MonetaryValue__times_impl_hlr6p7(it, $this$entry.baj($this.gf5_1.khd_1).u97()));
    return new (MonetaryValue())(tmp$ret$12);
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function itemSummary($this, _this__u8e3s4, item) {
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp_0 = view_0.ibb(get_expanding(view_0), get_centered(view_0));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_4(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_4(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(item).k20();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  var tmp_3 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
  dynamicTheme(view_2, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.baj(item).shc_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_individualStatus(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = DisplayableStateSemantic().mgt(tmp1_safe_receiver);
    }
    return tmp;
  });
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_5(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_5(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(item).shc_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_individualStatus(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.phf_1;
    var tmp$ret$9 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    this_1.set(tmp$ret$9);
    return Unit_instance;
  });
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_3, view_2);
  view.fbb(p_0, view_0);
  itemSummary$_anonymous_$smallEntry_4sjebx(view, 'This Draw', ($this$smallEntry) => {
    var tmp0_elvis_lhs = $this$smallEntry.baj(item).yhc_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
      tmp = Companion_instance.p91(0n);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return new (MonetaryValue())(tmp);
  });
  itemSummary$_anonymous_$smallEntry_4sjebx(view, 'Less Retention', ($this$smallEntry) => {
    var tmp0_safe_receiver = $this$smallEntry.baj(item).yhc_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = MonetaryValue__times_impl_hlr6p7(tmp0_safe_receiver, $this$smallEntry.baj($this.gf5_1.khd_1).u97());
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = Companion_instance.p91(0n);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return new (MonetaryValue())(tmp_1);
  });
  greySeparator(view);
  itemSummary$_anonymous_$smallEntry_4sjebx(view, 'Requested', ($this$smallEntry) => {
    var tmp0_safe_receiver = $this$smallEntry.baj(item).yhc_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
      tmp = null;
    } else {
      var tmp_1 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_1 == null ? null : new (MonetaryValue())(tmp_1)).a5s_1;
      tmp = MonetaryValue__minus_impl_jw9qyp(it, MonetaryValue__times_impl_hlr6p7(it, $this$smallEntry.baj($this.gf5_1.khd_1).u97()));
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_2;
    var tmp_3 = tmp1_elvis_lhs;
    if ((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null) {
      tmp_2 = Companion_instance.p91(0n);
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    return new (MonetaryValue())(tmp_2);
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_AppDimensions().ig2_1);
  var pending = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj($this.hf5_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6w_1) === true) {
        destination.v(element);
      }
    }
    return destination;
  });
  var allSelected = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp0 = $this$remember.baj(pending);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!$this$remember.baj($this.kf5_1).t1(element.rhc_1.kf9_1)) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
      }
      tmp$ret$3 = true;
    }
    if (tmp$ret$3) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj(pending).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  var labelValue = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(allSelected) ? ' All' : $this$remember.baj($this.kf5_1).p1() > 1 && $this$remember.baj($this.kf5_1).p1() < $this$remember.baj(pending).p1() ? ' (' + $this$remember.baj($this.kf5_1).p1() + ')' : '');
  var canVoid = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp_0;
    if ($this.df5_1.equals(ProjectLens_Contractor_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$remember.baj(pending).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = $this$remember.baj(pending);
      var tmp$ret$7;
      $l$block_2: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp0, Collection())) {
          tmp_1 = tmp0.i1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$7 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = element.shc_1;
          if (!equals(tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver), PayAppStatus_Pending_getInstance())) {
            tmp$ret$7 = false;
            break $l$block_2;
          }
        }
        tmp$ret$7 = true;
      }
      tmp = tmp$ret$7;
    } else {
      tmp = false;
    }
    return tmp;
  });
  var canPay = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp_0;
    if ($this.df5_1.equals(ProjectLens_Customer_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$remember.baj(pending).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj($this.kf5_1).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  var canWait = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp_0;
    if ($this.df5_1.equals(ProjectLens_Customer_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$remember.baj(pending).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj($this.kf5_1).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  if ($this.df5_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(canVoid)), view.hbb(DangerButtonSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    specCenteredText(view_0, 'Void');
    onClick(view_0, 'Void Draw', VOID, PayAppDetails$actionBar$slambda_0(pending));
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
  }
  if ($this.df5_1.equals(ProjectLens_Customer_getInstance())) {
    var tmp_0 = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(canPay)), get_primaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    specCenteredText_0(view_1, ($this$specCenteredText) => 'Pay' + $this$specCenteredText.baj(labelValue));
    onClick(view_1, 'Pay Selected Draws', VOID, PayAppDetails$actionBar$slambda_2(pending, $this, allSelected));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
  }
  if ($this.df5_1.equals(ProjectLens_Customer_getInstance())) {
    var tmp_1 = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(canWait)), get_dangerButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    specCenteredText_0(view_2, ($this$specCenteredText) => 'Wait' + $this$specCenteredText.baj(labelValue));
    onClick(view_2, 'Wait Selected Draws', VOID, PayAppDetails$actionBar$slambda_4(pending, $this));
    view.fbb(p_2, view_2);
    view.jbb(tmp_1, view_2);
  }
  if ($this.df5_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_2 = get_secondaryButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    var tmp_3 = KMutableProperty0();
    var tmp_4 = Button$_get_shown_$ref_hkylj1(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, Button$_set_shown_$ref_bpvuvj(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp0 = $this$reactiveScope.baj($this.hf5_1);
      var tmp$ret$22;
      $l$block_4: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection())) {
          tmp = tmp0.i1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$22 = false;
          break $l$block_4;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = element.shc_1;
          if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6v_1) == null)) {
            tmp$ret$22 = true;
            break $l$block_4;
          }
        }
        tmp$ret$22 = false;
      }
      var tmp$ret$24 = tmp$ret$22;
      this_0.set(tmp$ret$24);
      return Unit_instance;
    });
    specCenteredText(view_3, 'View Concerns');
    onClick(view_3, VOID, VOID, PayAppDetails$actionBar$slambda_6($this));
    view.fbb(p_3, view_3);
    view.jbb(tmp_2, view_3);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function itemSummary$_anonymous_$smallEntry_4sjebx(_this__u8e3s4, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.jbb(get_centered(view), body(view, key));
  var tmp = view.ibb(get_expanding(view), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.bbs(Align_End_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_6(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_6(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = value($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
var PayAppDetails$renderMainContent$slambdaClass;
function PayAppDetails$renderMainContent$slambda() {
  if (PayAppDetails$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.nhc_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppDetails$renderMainContent$slambdaClass = $;
  }
  return PayAppDetails$renderMainContent$slambdaClass;
}
function PayAppDetails$renderMainContent$slambda_0(this$0) {
  var i = new (PayAppDetails$renderMainContent$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function PayAppDetails$renderMainContent$lambda$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var tmp;
    switch ($next.b4_1) {
      case 0:
        tmp = requestedSummary(this$0, $this$swap);
        break;
      case 1:
        tmp = actualsSummary(this$0, $this$swap);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function PayAppDetails$renderMainContent$lambda(it) {
  return it.o6y_1;
}
function Link$_get_to_$ref_jq7esp_0(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x_0(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var PayAppDetails$actionBar$slambdaClass;
function PayAppDetails$actionBar$slambda() {
  if (PayAppDetails$actionBar$slambdaClass === VOID) {
    class $ {
      constructor($pending) {
        this.rhf_1 = $pending;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Void Draw', 'Are you sure you want to void the remaining draw items in this draw? This cannot be undone.', VOID, 'Void', VOID, tmp_0, VOID, VOID, VOID, VOID, PayAppDetails$actionBar$slambda$slambda_0(this.rhf_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppDetails$actionBar$slambdaClass = $;
  }
  return PayAppDetails$actionBar$slambdaClass;
}
function PayAppDetails$actionBar$slambda_0($pending) {
  var i = new (PayAppDetails$actionBar$slambda())($pending);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PayAppDetails$actionBar$slambdaClass_0;
function PayAppDetails$actionBar$slambda_1() {
  if (PayAppDetails$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor($pending, this$0, $allSelected) {
        this.ehd_1 = $pending;
        this.fhd_1 = this$0;
        this.ghd_1 = $allSelected;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppDetails$actionBar$slambdaClass_0 = $;
  }
  return PayAppDetails$actionBar$slambdaClass_0;
}
function PayAppDetails$actionBar$slambda_2($pending, this$0, $allSelected) {
  var i = new (PayAppDetails$actionBar$slambda_1())($pending, this$0, $allSelected);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PayAppDetails$actionBar$slambdaClass_1;
function PayAppDetails$actionBar$slambda_3() {
  if (PayAppDetails$actionBar$slambdaClass_1 === VOID) {
    class $ {
      constructor($pending, this$0) {
        this.ihf_1 = $pending;
        this.jhf_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppDetails$actionBar$slambdaClass_1 = $;
  }
  return PayAppDetails$actionBar$slambdaClass_1;
}
function PayAppDetails$actionBar$slambda_4($pending, this$0) {
  var i = new (PayAppDetails$actionBar$slambda_3())($pending, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var PayAppDetails$actionBar$slambdaClass_2;
function PayAppDetails$actionBar$slambda_5() {
  if (PayAppDetails$actionBar$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.mhf_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppDetails$actionBar$slambdaClass_2 = $;
  }
  return PayAppDetails$actionBar$slambdaClass_2;
}
function PayAppDetails$actionBar$slambda_6(this$0) {
  var i = new (PayAppDetails$actionBar$slambda_5())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function SummarySection_Requested_getInstance() {
  SummarySection_initEntries();
  return SummarySection_Requested_instance;
}
function SummarySection_Actual_getInstance() {
  SummarySection_initEntries();
  return SummarySection_Actual_instance;
}
var PayAppDetailsClass;
function PayAppDetails() {
  if (PayAppDetailsClass === VOID) {
    class $ {
      constructor(projectId, payAppId, lens) {
        this.bf5_1 = projectId;
        this.cf5_1 = payAppId;
        this.df5_1 = lens;
        var tmp = this;
        tmp.ef5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.baj($this$remember.baj(get_session()).afw_1.kft(this.cf5_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(PayApplication()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_0 = this;
        tmp_0.ff5_1 = remember(VOID, VOID, VOID, ($this$remember) => 'Draw ' + $this$remember.baj(this.ef5_1).k6y_1);
        this.gf5_1 = new (Data())(this.df5_1, this.bf5_1);
        var tmp_1 = this;
        tmp_1.hf5_1 = remember(VOID, VOID, VOID, ($this$remember) => getPaymentData($this$remember, this.gf5_1, $this$remember.baj(this.ef5_1)));
        var tmp_2 = this;
        tmp_2.if5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.baj(this.hf5_1);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.shc_1;
            var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver_0);
            }
          }
          return overallStatus(toSet(destination));
        });
        this.jf5_1 = Signal().fak(SummarySection_Requested_getInstance());
        this.kf5_1 = ReactiveMutableSet().zan();
      }
      rgj() {
        return this.df5_1;
      }
      ucv() {
        return this.ff5_1;
      }
      shf(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        launch(view, VOID, VOID, PayAppDetails$renderMainContent$slambda_0(this));
        var tmp = view.ibb(get_expanding(view), get_scrolling(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.zb8(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        var tmp_0 = get_lightSection(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        var tmp_1 = get_centered(view_3);
        view_3.jbb(tmp_1, title(view_3, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.baj(this.ff5_1);
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        }));
        var tmp_2 = view_3.ibb(get_centered(view_3), get_expanding(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_4);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_4));
        reactiveScope(view_4, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.ef5_1).m6y_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : format(tmp0_safe_receiver, Formats_getInstance().j8z_1);
          var tmp$ret$2 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          this_0.set(tmp$ret$2);
          return Unit_instance;
        });
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_2, view_4);
        var tmp_5 = view_3.ibb(get_centered(view_3), get_secondaryButton(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Link())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        specCenteredText(view_5, 'View Details');
        var tmp_6 = KMutableProperty0();
        var tmp_7 = Link$_get_to_$ref_jq7esp(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('to', 0, tmp_6, tmp_7, Link$_set_to_$ref_i9gu5x(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var $this$invoke = $this$reactiveScope;
          var tmp$ret$9 = () => new (PayAppSummary())($this$invoke.baj(this.ef5_1), $this$invoke.baj(this.gf5_1.khd_1), $this$invoke.baj(this.gf5_1.bhe_1), $this$invoke.baj(this.hf5_1));
          this_1.set(tmp$ret$9);
          return Unit_instance;
        });
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_5, view_5);
        view_2.fbb(p_3, view_3);
        label2(view_2, 'Status', VOID, ($this$label2) => title($this$label2, ($this$title) => {
          dynamicTheme($this$title, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(this.if5_1)));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_1($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$18 = $this$reactiveScope.baj(this.if5_1).vhf_1;
            this_0.set(tmp$ret$18);
            return Unit_instance;
          });
          return Unit_instance;
        }));
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_0, view_2);
        labeledSection(view_1, 'Summary', ($this$labeledSection) => {
          var tmp = $this$labeledSection.hbb(TabSemantics().ahg(AppColors_getInstance().ffz_1.zg9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$labeledSection.pc());
          var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
          $this$labeledSection.ebb(p, view);
          view.xbm(false);
          var _iterator__ex2g4s = get_entries().m1();
          while (_iterator__ex2g4s.n1()) {
            var section = _iterator__ex2g4s.o1();
            var tmp_0 = get_expanding(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (RadioToggleButton())(view.pc());
            var tmp0_elvis_lhs_0 = view.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.ebb(p_0, view_0);
            view_0.jbb(get_centered(view_0), body(view_0, section.lhc_1));
            view_0.xah(view_0.zc8_1, equalTo(this.jf5_1, section));
            view.fbb(p_0, view_0);
            view.jbb(tmp_0, view_0);
          }
          $this$labeledSection.fbb(p, view);
          $this$labeledSection.jbb(tmp, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (SwapView())($this$labeledSection.pc());
          var tmp0_elvis_lhs_1 = $this$labeledSection.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? $this$labeledSection : tmp0_elvis_lhs_1;
          $this$labeledSection.ebb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_0 = view_1;
          var queue = ArrayList().w();
          var alreadySwapping = {_v: false};
          reactiveScope(this_0, ($this$reactiveScope) => {
            var c = $this$reactiveScope.baj(this.jf5_1);
            queue.v(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.i1()) {
                break $l$loop;
              }
              var next = queue.z3(0);
              try {
                var tmp_0 = next.equals(SummarySection_Requested_getInstance()) ? Companion_getInstance().sax_1 : Companion_getInstance().rax_1;
                this_0.rci(tmp_0, PayAppDetails$renderMainContent$lambda$lambda$lambda(next, this));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          $this$labeledSection.fbb(p_1, view_1);
          return Unit_instance;
        });
        var tmp_8 = shownWhen(view_1, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = $this$shownWhen.baj(this.ef5_1).n6y_1;
          return !isBlank(this_0);
        });
        view_1.jbb(tmp_8, labeledSection(view_1, 'Description', ($this$labeledSection) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$labeledSection.pc());
          var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
          $this$labeledSection.ebb(p, view);
          view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_2(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_2(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$39 = $this$reactiveScope.baj(this.ef5_1).n6y_1;
            this_0.set(tmp$ret$39);
            return Unit_instance;
          });
          $this$labeledSection.fbb(p, view);
          return Unit_instance;
        }));
        var attachments = lens(this.ef5_1, PayAppDetails$renderMainContent$lambda);
        var tmp_9 = shownWhen(view_1, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(attachments).i1();
        });
        view_1.jbb(tmp_9, labeledSection(view_1, 'Attachments', ($this$labeledSection) => {
          $this$labeledSection.jbb(get_scrollingHorizontally($this$labeledSection), renderFiles($this$labeledSection, attachments, times(get_AppDimensions().qg2_1, 0.75)));
          return Unit_instance;
        }));
        view_0.fbb(p_1, view_1);
        var pending = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.hf5_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.shc_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6w_1) === true) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_10 = shownWhen(view_0, false, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(pending).i1();
        });
        view_0.jbb(tmp_10, label2(view_0, 'Pending Items', VOID, ($this$label2) => {
          var tmp = $this$label2.hbb(ReviewSelectionSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.xbm(true);
          view.zb8(get_AppDimensions().jg2_1);
          forEachUpdating(view, pending, VOID, ($this$forEachUpdating, it) => {
            var tmp = get_lightSection($this$forEachUpdating);
            // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (ToggleButton())($this$forEachUpdating.pc());
            var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
            $this$forEachUpdating.ebb(p, view);
            // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
            var value = this.df5_1.xgj();
            var tmp0 = view.mcq_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.disabled' call
            var value_0 = !value;
            tmp0.ib7_1.disabled = value_0;
            var isSelected = containsDynamic(this.kf5_1, ($this$containsDynamic) => $this$containsDynamic.baj(it).rhc_1.kf9_1);
            if (this.df5_1.xgj()) {
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (RowOrCol())(view.pc());
              var tmp0_elvis_lhs_0 = view.cbb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.ebb(p_0, view_0);
              view_0.xbm(false);
              var tmp_0 = get_centered(view_0);
              // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (Checkbox())(view_0.pc());
              var tmp0_elvis_lhs_1 = view_0.cbb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
              view_0.ebb(p_1, view_1);
              view_1.xah(view_1.cbk_1, isSelected);
              view_0.fbb(p_1, view_1);
              view_0.jbb(tmp_0, view_1);
              view_0.jbb(get_expanding(view_0), itemSummary(this, view_0, it));
              view.fbb(p_0, view_0);
            } else
              itemSummary(this, view, it);
            if (this.df5_1.xgj()) {
              view.xah(view.ncq_1, isSelected);
            }
            $this$forEachUpdating.fbb(p, view);
            $this$forEachUpdating.jbb(tmp, view);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return $this$label2.jbb(tmp, view);
        }));
        var reviewed = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.hf5_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.shc_1;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6w_1) === false) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_11 = shownWhen(view_0, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(reviewed).i1();
        });
        view_0.jbb(tmp_11, label2(view_0, 'Reviewed Items', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          view.xbm(true);
          view.zb8(get_AppDimensions().jg2_1);
          forEachUpdating(view, reviewed, VOID, ($this$forEachUpdating, item) => {
            // Inline function 'com.lightningkite.kiteui.views.direct.link' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (Link())($this$forEachUpdating.pc());
            var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
            $this$forEachUpdating.ebb(p, view);
            dynamicTheme(view, ($this$dynamicTheme) => {
              var tmp0_safe_receiver = $this$dynamicTheme.baj(item).shc_1;
              var tmp1_subject = tmp0_safe_receiver == null ? null : get_individualStatus(tmp0_safe_receiver);
              var tmp;
              switch (tmp1_subject == null ? -1 : tmp1_subject.b4_1) {
                case 0:
                  tmp = LightSection_getInstance();
                  break;
                case 1:
                  tmp = DeniedSemantic_getInstance().ybe(CardSemantic_getInstance());
                  break;
                case 2:
                  tmp = ApprovedSemantic_getInstance().ybe(CardSemantic_getInstance());
                  break;
                case 3:
                  tmp = DarkSection_getInstance();
                  break;
                case -1:
                  tmp = LightSection_getInstance();
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              return tmp;
            });
            itemSummary(this, view, item);
            var tmp = KMutableProperty0();
            var tmp_0 = Link$_get_to_$ref_jq7esp_0(view);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x_0(view));
            reactiveScope(view, ($this$reactiveScope) => {
              var $this$invoke = $this$reactiveScope;
              var tmp0_safe_receiver = $this$invoke.baj(item).shc_1;
              var tmp;
              if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6v_1) == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.collections.filter' call
                var tmp0 = $this$invoke.baj(this.hf5_1);
                // Inline function 'kotlin.collections.filterTo' call
                var destination = ArrayList().w();
                var _iterator__ex2g4s = tmp0.m1();
                while (_iterator__ex2g4s.n1()) {
                  var element = _iterator__ex2g4s.o1();
                  if (!(element.shc_1 == null)) {
                    destination.v(element);
                  }
                }
                var drawData = destination;
                tmp = () => {
                  var tmp = $this$invoke.baj(this.ef5_1);
                  // Inline function 'kotlin.collections.mapNotNull' call
                  var tmp0 = drawData;
                  // Inline function 'kotlin.collections.mapNotNullTo' call
                  var destination = ArrayList().w();
                  // Inline function 'kotlin.collections.forEach' call
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    var tmp0_safe_receiver = element.shc_1;
                    if (tmp0_safe_receiver == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      destination.v(tmp0_safe_receiver);
                    }
                  }
                  var tmp_0 = destination;
                  // Inline function 'kotlin.collections.associate' call
                  var this_0 = drawData;
                  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
                  // Inline function 'kotlin.collections.associateTo' call
                  var destination_0 = LinkedHashMap().fc(capacity);
                  var _iterator__ex2g4s_0 = this_0.m1();
                  while (_iterator__ex2g4s_0.n1()) {
                    var element_0 = _iterator__ex2g4s_0.o1();
                    // Inline function 'kotlin.collections.plusAssign' call
                    var pair = to(element_0.rhc_1.kf9_1, element_0.rhc_1);
                    destination_0.s3(pair.af_1, pair.bf_1);
                  }
                  return new (DrawWaitedDetails())(tmp, tmp_0, destination_0, $this$invoke.baj(this.gf5_1.rhd_1).f5c_1, $this$invoke.baj(this.gf5_1.thd_1).x5i_1);
                };
              }
              var tmp$ret$91 = tmp;
              this_0.set(tmp$ret$91);
              return Unit_instance;
            });
            $this$forEachUpdating.fbb(p, view);
            return Unit_instance;
          });
          $this$label2.fbb(p, view);
          return view;
        }));
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        var tmp_12 = get_darkSection(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_6 = view.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
        view.ebb(p_6, view_6);
        view_6.eba(div(get_AppDimensions().xg1_1, 2));
        view_6.jbb(align(view_6, Align_End_getInstance(), Align_Center_getInstance()), actionBar(this, view_6));
        view.fbb(p_6, view_6);
        view.jbb(tmp_12, view_6);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).bhg = get_requiredMembershipRole;
    protoOf($).chg = get_finishRegistrationMessage;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'PayAppDetails', VOID, VOID, [MightBeContractorPage()]);
    PayAppDetailsClass = $;
  }
  return PayAppDetailsClass;
}
//region block: exports
export {
  PayAppDetails as PayAppDetails12i3yidr5kt7h,
};
//endregion

//# sourceMappingURL=PayAppDetails.mjs.map
